// Flag-gated items at the bottom of the header farming-unit dropdown:
// "+ Create new" (opens the Create new farming unit modal, then the Farming unit
// editor) and "Manage farming unit" (opens the editors for the selected unit).
// FarmingUnitsDropdown renders this only when the `new_season` flag is on.
const React = require('react');
const { useState, useCallback } = require('react');
const { useSelector } = require('react-redux');
const { useNavigate } = require('react-router-dom');
const { useTranslation } = require('react-i18next');
const $ = require('jquery');
const FarmingUnitFormModal = require('./FarmingUnitFormModal');
const { farmingUnitEditorUrl } = require('./newSeasonConstants');
const { registerNewSeasonTranslations } = require('./newSeasonTranslations');

require('./newSeason.scss');

registerNewSeasonTranslations();

const plusIcon = require('images/icons/plus_icon.svg');

const itemStyle = {
  borderRadius: '3px',
  padding: '8px 4px 8px 4px',
  gap: '4px',
  justifyContent: 'center',
};

const closeDropdown = () => $('.dropdown-toggle').dropdown('hide');

const NewSeasonFarmingUnitMenuItems = ({ isAdmin, hasFarmingUnits }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const distribution = useSelector(
    (state) => state.distribution_data?.selected_entities?.distribution,
  );
  const farmingUnit = useSelector(
    (state) => state.distribution_data?.selected_entities?.farming_unit,
  );

  const openCreateModal = (event) => {
    event.preventDefault();
    closeDropdown();
    setIsModalOpen(true);
  };

  const openManage = (event) => {
    event.preventDefault();
    closeDropdown();
    navigate(farmingUnitEditorUrl(distribution.id, farmingUnit.id));
  };

  const closeModal = useCallback(() => setIsModalOpen(false), []);
  const onCreated = useCallback(
    (farmingUnitId) => {
      setIsModalOpen(false);
      navigate(farmingUnitEditorUrl(distribution?.id, farmingUnitId));
    },
    [navigate, distribution?.id],
  );

  return (
    <div
      className='ns-dropdown-footer'
      style={{ borderTopWidth: hasFarmingUnits ? 1 : 0 }}
    >
      {isAdmin && distribution && (
        <a
          className='d-flex dropdown-item text-grey45 font-weight-semi-bold text-size-14'
          style={itemStyle}
          href='#'
          onClick={openCreateModal}
        >
          <img
            style={{ paddingBottom: '2px' }}
            src={plusIcon}
            className='img-fluid'
            alt=''
          />
          {t('new_season_create_new')}
        </a>
      )}
      {distribution && farmingUnit && (
        <a
          className='d-flex dropdown-item text-grey45 font-weight-semi-bold text-size-14'
          style={itemStyle}
          href='#'
          onClick={openManage}
        >
          {t('new_season_manage_farming_unit')}
        </a>
      )}
      <FarmingUnitFormModal
        isOpen={isModalOpen}
        mode='create'
        distributionId={distribution?.id}
        onClose={closeModal}
        onCreated={onCreated}
      />
    </div>
  );
};

module.exports = NewSeasonFarmingUnitMenuItems;
